import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .MuiDivider-root {
    width: 100%;
    margin-top: 1rem;
  }
`
